import React from "react";
import {
  SideBarSubContainer,
  Line,
  SubMenuContainer,
  SideBarSubButton,
  SideBarSubButtonActive,
} from "./styles";
import { useNavigate } from "react-router-dom";
import { useNavigationStore } from "store/navigationStore";

interface SubMenuItem {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  isProductFlow?: boolean;
}

interface SubMenuProps {
  isCollapsed: boolean;
  isOpen: boolean;
  items: SubMenuItem[];
  activeButton: string;
}

export const SubMenu: React.FC<SubMenuProps> = ({
  isCollapsed,
  isOpen,
  items,
  activeButton,
}) => {
  const navigate = useNavigate();
  const { setActiveButton } = useNavigationStore();

  const handleSubMenuClick = (subItem: SubMenuItem) => {
    if (subItem.disabled) {
      return;
    }

    if (subItem.isProductFlow) {
      navigate("/upload", {
        state: {
          from: window.location.pathname,
        },
      });
      return;
    }

    setActiveButton(subItem.id);
    subItem.onClick();
  };

  if (isCollapsed) return null;

  return (
    <SideBarSubContainer $isSubMenuOpen={isOpen}>
      <Line />
      <SubMenuContainer $isSubMenuOpen={isOpen}>
        {items.map((item) => (
          <SideBarSubButton
            key={item.id}
            onClick={() => handleSubMenuClick(item)}
            $isCollapsed={isCollapsed}
            as={
              !isCollapsed && activeButton === item.id
                ? SideBarSubButtonActive
                : SideBarSubButton
            }
          >
            <span>{item.label}</span>
          </SideBarSubButton>
        ))}
      </SubMenuContainer>
    </SideBarSubContainer>
  );
};
